import { createSlice } from '@reduxjs/toolkit';

/**
 * @type { import(
 *   '../../apis/act/getLineReceptionListApiTypes'
 * ).getLineReceptionListGetResponse }
 */
const initialState = {
  message: '',
  description: '',
  isLoading: true,
  data: {
    total: 0,
    guidances: [],
  },
};

export const lineReceptionListSlice = createSlice({
  name: 'lineReceptionList',
  initialState,
  reducers: {
    updateLineReceptionList: (state, action) => {
      state.message = action.payload.message;
      state.description = action.payload.description;
      state.data = action.payload.data;
      state.isLoading = false;
    },
  },
});

export const { updateLineReceptionList } = lineReceptionListSlice.actions;

export default lineReceptionListSlice.reducer;
